import { render, staticRenderFns } from "./PosterStory.vue?vue&type=template&id=dd54f9a0&scoped=true"
import script from "./PosterStory.vue?vue&type=script&lang=js"
export * from "./PosterStory.vue?vue&type=script&lang=js"
import style0 from "./PosterStory.vue?vue&type=style&index=0&id=dd54f9a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd54f9a0",
  null
  
)

export default component.exports